import axios from 'axios'
let userdata = JSON.parse(localStorage.getItem('flaacos_user'));
let token;
if(userdata && userdata.attendee_token!='' && userdata.attendee_token!=undefined){
    token = userdata.attendee_token;
}
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://staging.flaacosvirtualconference.com:3335/user/' : 'http://127.0.0.1:3334/user/';
axios.defaults.headers.common = {
    "Authorization": "Bearer "+token,
    "Accept" : 'application/json'
};
// axios.interceptors.response.use(response => {
//     return response;
// }, error => {
//     if (error.response.status === 401) {
//         localStorage.removeItem('flaacos_user')
//         window.location = '/'
//     }
//     return error;
// });
export default axios